export default __webpack_public_path__ + "static/media/657.e091b500.png";